import React from 'react';

const Steps = ({ current }) => {
    const steps = [1, 2, 3];
    return (
        <div className={`steps step-${current}`}>
            {steps.map((item, i) => {
                return <span className={`step ${current === i + 1 ? 'active' : ''}`}>{item}</span>;
            })}
        </div>
    );
};

export default Steps;
